import React from 'react';
import './Button.css';

const propTypes = {
  type: React.PropTypes.oneOf([
    'blend',
    'blue',
    'outline',
    'white',
    'red',
    'green',
  ]).isRequired,
  size: React.PropTypes.oneOf([
    'sm',
    'md',
    'lg'
  ]).isRequired,
  textColor: React.PropTypes.oneOf([
    'blue',
    'red',
    'white'
  ]),
  onClick: React.PropTypes.func
}

const Button = props => (
  <button
    className={`btn btn--${props.size} btn--${props.type} ${props.textColor ? 'btn--text-' + props.textColor : ''}`}
    type='button'
    onClick={props.onClick}>
    {props.children}
  </button>
)

Button.propTypes = propTypes;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js